import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="site-footer__columns">
        <div className="site-footer__column">
          <h4>
            <span className="phi-logo">ϕ</span> PHI Printing
          </h4>
          <p>Custom photo prints and fine art from independent artists.</p>
        </div>
        <div className="site-footer__column">
          <h4>Shop</h4>
          <Link to="/create-print">Create a Print</Link>
          <Link to="/art">Art Shop</Link>
          <Link to="/art/browse">Browse Gallery</Link>
          <Link to="/become-an-artist">Become an Artist</Link>
        </div>
        <div className="site-footer__column">
          <h4>Support</h4>
          <Link to="/history">Order History</Link>
          <Link to="/returns-policy">Returns &amp; Refunds</Link>
          <Link to="/returns">My Returns</Link>
          <a href="mailto:support@phiprinting.com">Contact Us</a>
        </div>
        <div className="site-footer__column">
          <h4>Legal</h4>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cookies">Cookie Policy</Link>
          <Link to="/copyright">Copyright &amp; IP</Link>
        </div>
      </div>
      <div className="site-footer__bottom">
        <p>© {new Date().getFullYear()} PHI Printing. All artwork © its respective artist.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
